export enum RelacaoImovelTipo {
  PROPRIO = 'PROPRIO',
  LOCADO = 'LOCADO',
  EMPRESTADO = 'EMPRESTADO',
  CEDIDO = 'CEDIDO',
  OUTRO = 'OUTRO',
}
